import { IGestBrand } from "@shared/library";
import importer from "../helpers/importer";

export const SHELL_BRAND: IGestBrand = {
    appName: "WebGest",
    logo: importer.img.require("webGestLogo.svg"),
    sidebarLogo: "/favicon.svg",
};

export const AVAILABLE_LANGUAGES = [
    { id: "it", name: "italian" },
    { id: "en", name: "english", iconName: "gb" },
    { id: "fr", name: "french" },
];

export const HOME_PATH = "/";
export const ADMIN_PANEL_PATH = "/AdminPanel";
